import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http'

export interface Poll {
  id: number,
  name: string,
  subname: string,
  description: string,
  tags?: string
}
@Injectable({
  providedIn: 'root'
})
export class PollService {

  constructor(private http: HttpClient) { }

  getCurrentPoll(poll: string) {
    return this.http.get<any>(environment.api_url + 'api/v1.0/polls/id/' + poll)
  }

  run(id:string, body: any) {
    return this.http.post(environment.api_url + 'api/v1.0/pollfields/id/'+ id +'/saveans',  body);
  }

  getPollStatistics(id: string) {
    return this.http.get(environment.api_url + 'api/v1.0/polls/stats/id/' + id);
  }

  getPolls() {
    return this.http.get<Poll[]>(environment.api_url + 'api/v1.0/polls/')
  }
  
  AddPoll(body) {
    return this.http.post<Poll>(environment.api_url + 'api/v1.0/polls/', body)
  }
  EditPoll(id, body) {
    return this.http.patch<Poll>(environment.api_url + 'api/v1.0/polls/id/'+ id, body)
  }
  DeletePoll(id) {
    return this.http.delete(environment.api_url + 'api/v1.0/polls/id/' + id)
  }
  getPollFields(id) {
    return this.http.get<any>(environment.api_url + 'api/v1.0/pollfields/id/' + id + '/poll')
  }
  AddField(id, body) {
    return this.http.post(environment.api_url + 'api/v1.0/pollfields/id/'+id+'/poll', body)
  }
  EditField(id, body) {
    return this.http.patch(environment.api_url + 'api/v1.0/pollfields/id/'+id, body)
  }
  DeleteField(id) {
    return this.http.delete(environment.api_url + 'api/v1.0/pollfields/id/'+id)
  }
  ChangePrivate(id:string) {
    return this.http.get<any>(environment.api_url + 'api/v1.0/polls/changeprivate/id/' + id)
  }

}
